;(function () {
  angular.module('contrast.avatar').directive('avatarPicker', avatarPicker)

  function avatarPicker(avatarService) {
    'ngInject'

    return {
      restrict: 'A',
      scope: {
        onUpload: '&',
        onCrop: '&',
        onError: '&'
      },
      controller: 'csAvatarCtrl',
      controllerAs: 'avatarCtrl',
      link: link
    }

    function link(scope, element) {
      var cropButton = element.find('.btn-crop')

      avatarService.createAvatarPicker(
        element,
        cropButton,
        scope.onCrop(),
        scope.onUpload(),
        angular.noop,
        onError
      )

      function onError(title, content) {
        scope.onError()(title, content)
      }
    }
  }
})()
